import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import * as filters from './filters.js'

import Meta from 'vue-meta'
import Cookie from 'vue-cookie'
import Seo from './seo.js'
import VueProgressBar from 'vue-progressbar'
import SocialSharing from 'vue-social-sharing'

import App from './App.vue'
import createStore from './store'
import createRouter from './router.js'

Vue.use(VueProgressBar, {
  color: '#233780',
  failedColor: '#bd0202',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
})
Vue.use(Meta)
Vue.use(Cookie)
Vue.use(Seo)
Vue.use(SocialSharing)

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

export default function createApp (context) {
  const store = createStore()
  if (context.host.indexOf('localhost') === -1) {
    if (context.host.indexOf('siteuo.ru') !== -1) {
      store.state.api = 'https://' + context.host.replace('siteuo.ru', 'api.siteuo.ru')
    } else {
      store.state.api = 'https://api.' + context.host
    }
  }
  const router = createRouter()
  sync(store, router)

  const app = new Vue({
    router,
    store,
    render: h => h(App)
  })

  return {
    app,
    router,
    store
  }
}
